import { useNavigate } from 'react-router-dom'

export default function Footer() {
  const navigate = useNavigate()

  return (
    <footer className="bg-dark-100 border-t border-dark-200 mt-auto">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          
          {/* Company Info */}
          <div className="text-center sm:text-left">
            <p className="text-sm text-vapour-700 font-medium">VapourVape Rewards</p>
            <p className="text-xs text-vapour-600">© 2025 VapourVape. All rights reserved.</p>
          </div>

          {/* Legal Links */}
          <div className="flex flex-wrap justify-center sm:justify-end gap-4 text-xs">
            <button
              onClick={() => navigate('/privacy')}
              className="text-vapour-600 hover:text-vapour-900 underline transition-colors"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => navigate('/terms')}
              className="text-vapour-600 hover:text-vapour-900 underline transition-colors"
            >
              Terms of Service
            </button>
            <button
              onClick={() => navigate('/terms-conditions')}
              className="text-vapour-600 hover:text-vapour-900 underline transition-colors"
            >
              Terms & Conditions
            </button>
          </div>

        </div>

        {/* Additional Info */}
        <div className="mt-4 pt-4 border-t border-dark-200">
          <p className="text-xs text-vapour-600 text-center">
            Questions about our loyalty program? Contact us at{' '}
            <a 
              href="mailto:support@vapourvape.com" 
              className="text-vapour-700 hover:text-vapour-900 underline"
            >
              support@vapourvape.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}